import { render, staticRenderFns } from "./screenTic.vue?vue&type=template&id=44060d22"
import script from "./screenTic.vue?vue&type=script&lang=js"
export * from "./screenTic.vue?vue&type=script&lang=js"
import style0 from "./screenTic.vue?vue&type=style&index=0&id=44060d22&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports